<template>
    <div>

        <div class="card" style="max-width: 100%">
            <div class="card-header"><b>Listar Usuarios</b></div>
            <div class="card-body text-dark">
                
                <b-modal id="crearUsuario" size="lg" title="Crear Usuario" hide-footer>
                    
                    <form>
                        <div class="row">
                            <div class="form-group col-sm-12">
                                <label>Nombre Completo</label>
                                <input type="text" class="form-control" v-model="users.name" required>
                            </div>   
                            <div class="form-group col-sm-12">
                                <label>Correo Electrónico</label>
                                <input type="email" class="form-control" v-model="users.email">
                            </div>                                
                            <div class="form-group col-sm-12">
                                <label>Contraseña</label>
                                <input type="password" class="form-control" v-model="users.password" required>
                            </div>                       
                            <div class="form-group col-sm-12">
                                <label>Seleccionar Rol</label>                     
                                <select v-model="users.id_rol" class="form-control">
                                    <option :value="rols.id" v-for="rols in roles" v-bind:key="rols.id">{{ rols.nombre }}</option>
                                </select>
                            </div>                 
                            <div class="form-group col-sm-12">
                                <center>                                        
                                    <button type="submit" @click.prevent="saveUser" class="btn btn-success">Guardar</button>                                    
                                </center>
                            </div>                                         
                        </div>
                    </form>

                </b-modal> 

                <div class="row">

                    <div class="col-sm-5">
                        <b-button class="btn btn-add-vg" v-b-modal.crearUsuario @click="resetForm(); editedIndex= 1;"><i class="mdi mdi-plus"></i> Crear Usuario</b-button><br><br>
                    </div>
                    <div class="col-sm-6">
                        <b-form-input
                        class="col-sm-12"
                        v-model="filter"
                        type="search"
                        placeholder="Busqueda"
                        ></b-form-input>
                    </div>
                    <div class="col-sm-1">
                        <b-button class="btn btn-info" style="float: right;" @click="getUsers"><i class="mdi mdi-replay"></i></b-button>                        
                    </div>                    

                </div> 

                <div class="text-center" v-if="loading">
                    <b-spinner variant="primary" label="Text Centered"></b-spinner>
                </div>              
                <b-table
                class="table responsive table-bordered"               
                stacked="md"
                show-empty
                small
                :per-page="perPage"
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :filter="filter"
                @filtered="onFiltered"
                >
                    <template #cell(actions)="row">
                         <b-modal :id="'user'+row.item.id" size="lg" :title="title" hide-footer>
                                
                            <form>
                                <div class="row">
                                    <div class="form-group col-sm-12">
                                        <label>Nombre Completo</label>
                                        <input type="text" class="form-control" v-model="users.name" :disabled="disabled" required>
                                    </div>   
                                    <div class="form-group col-sm-12">
                                        <label>Correo Electrónico</label>
                                        <input type="email" class="form-control" v-model="users.email" :disabled="disabled">
                                    </div>                                   
                                    <div class="form-group col-sm-12">
                                        <label>Contraseña</label>
                                        <input type="password" class="form-control" v-model="users.password" :disabled="disabled" required>
                                    </div>                       
                                    <div class="form-group col-sm-12">
                                        <label>Seleccionar Rol</label>                     
                                        <select v-model="users.id_rol" class="form-control" :disabled="disabled">
                                            <option :value="rols.id" v-for="rols in roles" v-bind:key="rols.id">{{ rols.nombre }}</option>
                                        </select>
                                    </div>                          
                                    <div class="form-group col-sm-12">
                                        <center>                                        
                                            <button type="submit" @click.prevent="saveUser" :disabled="disabled" class="btn btn-success">Guardar</button>                                    
                                        </center>
                                    </div>                                         
                                </div>
                            </form>

                        </b-modal>  
                        <b-button class="btn btn-info" @click="$bvModal.show('user'+row.item.id); showModal(row.item, true, 'Ver Usuario')" v-b-tooltip.hover title="Ver Usuario"><i class="mdi mdi-eye"></i></b-button>&nbsp;
                        <b-button class="btn btn-warning" @click="$bvModal.show('user'+row.item.id); showModal(row.item, false, 'Editar Usuario'); editedIndex= -1;" v-b-tooltip.hover title="Editar Usuario"><i class="mdi mdi-pencil text-white"></i></b-button>&nbsp;
                        <b-button class="btn btn-danger" @click="deleteUser(row.item)" v-b-tooltip.hover title="Eliminar Usuario"><i class="mdi mdi-delete"></i></b-button>&nbsp;
                        <b-button class="btn btn-success" @click="activarUsuario(row.item)" v-if="row.item.estado == 1" v-b-tooltip.hover title="Activar Usuario"><i class="mdi mdi-clipboard-check"></i></b-button> 
                    </template>
                </b-table>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                ></b-pagination>

            </div>
        </div> 

    </div>
</template>
<script>
import {headers} from './../../../api/headers'
import {configApi} from './../../../api/configApi'
export default {
    name: 'listado_users',
    data: () => ({
        perPage: 5,
        filter: null,
        currentPage: 1,
        loading: true, 
        disabled: false,
        title: '',
        items: [],
        roles: [], 
        paises: [],        
        fields: [
          { key: 'id', label: 'ID', sortable: true },
          { key: 'name', label: 'Nombre', sortable: true, class: 'text-center' },   
          { key: 'email', label: 'Correo Electrónico', sortable: true, class: 'text-center' },              
          { key: 'rol', label: 'Rol Usuario', sortable: true, class: 'text-center' },   
          { key: 'actions', label: 'Acciones', class: 'text-center' }
        ],      
        editedIndex: -1,
        users: {
            id: '',
            name: '',
            email: '',
            password: '',
            id_rol: '',
        },     
    }),
    computed: {
        formTitle () {
            return this.editedIndex === -1 ? 'Nuevo Usuario' : 'Editar Usuario'
        },       
        rows() {
            return this.items.length;
        },
    },
    mounted() {
        this.getRoles()       
    },
    watch: {
 
    },

    created () {
        this.getUsers()
    },

    methods: {   
        showModal(datos, disabled, title) {            
            this.disabled = disabled
            this.title = title
            this.users.id = datos.id
            this.users.name = datos.name
            this.users.email = datos.email
            this.users.password = datos.password
            this.users.id_rol = datos.id_rol
        },   
        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
        },
        async getUsers() {

            return await this.axios.get(configApi+'usuarios/users', {headers})
            .then(response => {
                this.items = response.data.data;
                this.loading = false 
            })

        },
        async getRoles() {

            return await this.axios.get(configApi+'roles', {headers})
            .then(response => {
                                  
                this.roles = response.data.data;
                                              
            })

        },        
        async saveUser () {
            
            if (this.editedIndex == -1) {

                return await this.axios.put(configApi+'usuarios/users/'+this.users.id, this.users, {headers})
                .then(response => {   
                    this.$bvModal.hide('user'+this.users.id)  
                    this.resetForm()                 
                    this.getUsers()
                    this.$Fun.alertaAccion('success', response.data.message, false)
                })

            } else {

                return await this.axios.post(configApi+'usuarios/users', this.users, {headers})
                .then(response => {
                    this.$bvModal.hide('crearUsuario')  
                    this.resetForm()
                    this.getUsers()
                    this.$Fun.alertaAccion('success', response.data.message, false)
                })   
                
            }            
            
        }, 
        async deleteUser(data) {   

            let objAlert = {
                titleAlert: '¿Desea eliminar el Usuario?',
                url: configApi+'usuarios/users/'+ data.id, // url delete 
                headers: {headers},
                messageError: 'El Usuario no fue Eliminado'
            }

            this.$Fun.alertaConfirmarEliminarAccion(objAlert, e => {
                if(e) {
                    this.getUsers()  
                }
            })                       
            
        },
        async activarUsuario(data) {            

            let objAlert = {
                titleAlert: '¿Desea activar este usuario?',
                url: configApi+'usuarios/activa_usuario/'+ data.id, 
                request: data,
                headers: {headers},
                messageError: 'El Usuario no fue activado'
            }

            this.$Fun.alertaConfirmarEstadoAccion(objAlert, e => {
                if(e) {
                    this.getUsers()  
                }
            }) 

        },
        resetForm() {
            this.users.id = ''
            this.users.name = ''
            this.users.email = ''
            this.users.usuario = ''
            this.users.password = ''
            this.users.id_rol = ''
            this.users.id_pais = ''
        }
    },       
}
</script>